var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, hasMany } from '@ember-data/model';
import { computed, set } from '@ember/object';
import { isNone, isEmpty } from '@ember/utils';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
import { isListModifierType } from '@square/dashboard-items-data/utils/modifiers';
import { CatalogModifierListSelectionType as ModifierListSelectionTypeProto, CatalogModifierListModifierType as ModifierListModifierTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import NumericEnum from '@square/dashboard-utilities/utils/numeric-enum';
export const SelectionType = NumericEnum.createFromObject(ModifierListSelectionTypeProto);
export const ModifierType = NumericEnum.createFromObject(ModifierListModifierTypeProto);
export const TEXT_MODIFIER_MAX_LENGTH = 150;
let ItemModifierList = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('number'), _dec4 = attr('number'), _dec5 = attr('number'), _dec6 = attr('boolean', {
  defaultValue: false
}), _dec7 = attr('enum', {
  enumClass: ModifierType,
  defaultValue: ModifierType.LIST
}), _dec8 = attr('enum', {
  enumClass: SelectionType
}), _dec9 = attr('boolean', {
  allowNull: true
}), _dec10 = attr('boolean', {
  allowNull: true
}), _dec11 = attr('number', {
  defaultValue: TEXT_MODIFIER_MAX_LENGTH
}), _dec12 = attr('boolean', {
  defaultValue: false
}), _dec13 = hasMany('item-item-modifier-list-membership', {
  async: false
}), _dec14 = hasMany('item-modifier-option', {
  async: false
}), _dec15 = computed('itemModifierOptions.@each.isPlaceholder'), _dec16 = computed('_actualItemModifierOptions', 'nonPlaceholderItemModifierOptions.@each.{isDeleted,ordinal}'), _dec17 = computed('hasDirtyFields', 'nonPlaceholderItemModifierOptions.@each.isDirty'), _class = (_class2 = class ItemModifierList extends ItemsV3Base {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "internalName", _descriptor2, this);
    _initializerDefineProperty(this, "ordinal", _descriptor3, this);
    _initializerDefineProperty(this, "minSelectedModifiers", _descriptor4, this);
    _initializerDefineProperty(this, "maxSelectedModifiers", _descriptor5, this);
    _initializerDefineProperty(this, "allowQuantities", _descriptor6, this);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - TS doesn't like the enumClass type
    _initializerDefineProperty(this, "modifierType", _descriptor7, this);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - TS doesn't like the enumClass type
    _initializerDefineProperty(this, "selectionType", _descriptor8, this);
    _initializerDefineProperty(this, "isConversational", _descriptor9, this);
    _initializerDefineProperty(this, "hiddenFromCustomer", _descriptor10, this);
    // Text modifier specific attributes
    _initializerDefineProperty(this, "maxLength", _descriptor11, this);
    _initializerDefineProperty(this, "textRequired", _descriptor12, this);
    _initializerDefineProperty(this, "itemItemModifierListMemberships", _descriptor13, this);
    _initializerDefineProperty(this, "itemModifierOptions", _descriptor14, this);
    _defineProperty(this, "_actualItemModifierOptions", void 0);
  }
  static catalogType() {
    return 'ITEM_MODIFIER_LIST';
  }
  static createDefaultOptions() {
    return {
      selectionType: SelectionType.MULTIPLE,
      modifierType: ModifierType.LIST
    };
  }
  get isSingleSelection() {
    return this.selectionType === SelectionType.SINGLE;
  }
  set isSingleSelection(value) {
    this.selectionType = value ? SelectionType.SINGLE : SelectionType.MULTIPLE;
  }
  get nonPlaceholderItemModifierOptions() {
    return this.itemModifierOptions.rejectBy('isPlaceholder');
  }
  get actualItemModifierOptions() {
    if (this._actualItemModifierOptions !== undefined) {
      return this._actualItemModifierOptions;
    }
    return this.nonPlaceholderItemModifierOptions.rejectBy('isDeleted').sort((option1, option2) => option1.ordinal - option2.ordinal);
  }
  set actualItemModifierOptions(value) {
    set(this, '_actualItemModifierOptions', value);
  }
  get isDirty() {
    if (this.nonPlaceholderItemModifierOptions.isAny('isDirty')) {
      return true;
    }
    return this.hasDirtyFields;
  }
  addAffectedRelatedObjects(subunitToken) {
    const subunits = this.subunits;
    const subunitToAdd = subunits.findBy('token', subunitToken);
    if (!isNone(subunitToAdd)) {
      this.itemModifierOptions.rejectBy('isDeleted').forEach(option => option.addMerchantSubunit(subunitToAdd));
    }
  }
  removeAffectedRelatedObjects(subunitToken) {
    this.itemModifierOptions.rejectBy('isDeleted').forEach(option => option.removeMerchantSubunit(subunitToken));
  }
  updateGloballyEnabledForRelationships(globallyEnabled) {
    this.itemModifierOptions.forEach(option => {
      option.set('globallyEnabled', globallyEnabled);
    });
  }

  /**
   * The modifier name to use when displaying a modifier in Dashboard workflows
   * If the internal name exists, use that; otherwise, use the display name (aka name)
   */
  get modifierName() {
    return isEmpty(this.internalName) ? this.name : this.internalName;
  }
  get isListType() {
    return isListModifierType(this.modifierType);
  }
  get isTextType() {
    return this.modifierType === ModifierType.TEXT;
  }
  rollbackAttributes(rollbackRelationships = true) {
    super.rollbackAttributes();
    if (rollbackRelationships) {
      this.itemItemModifierListMemberships?.forEach(membership => {
        membership.rollbackAttributes();
      });
      this.itemModifierOptions?.forEach(option => {
        option?.rollbackAttributes();
      });
    }
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'item-modifier-list'), _defineProperty(_class2, "SelectionType", SelectionType), _defineProperty(_class2, "ModifierType", ModifierType), _defineProperty(_class2, "sortKey", 'name'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "internalName", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "minSelectedModifiers", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "maxSelectedModifiers", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "allowQuantities", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "modifierType", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "selectionType", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isConversational", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "hiddenFromCustomer", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "maxLength", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "textRequired", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "itemItemModifierListMemberships", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "itemModifierOptions", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "nonPlaceholderItemModifierOptions", [_dec15], Object.getOwnPropertyDescriptor(_class.prototype, "nonPlaceholderItemModifierOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "actualItemModifierOptions", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "actualItemModifierOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDirty", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "isDirty"), _class.prototype), _class);
export { ItemModifierList as default };